export enum Routes {
  FleetVehicleRouter = "*",
  FleetVehicleSearchPageRouter = "/fleet/vehicle/search",
  FleetVehicleDetailPageRouter = "/fleet/vehicle/:id/detail/",
  FleetVehicleEditPageRouter = "/fleet/vehicle/:id/edit/",
  FleetVehicleCreatePageRouter = "/fleet/vehicle/new",
  FleetVehiclePictureCreatePageRouter = "/fleet/vehicle/:id/picture/new",
  FleetVehiclePictureEditPageRouter = "/fleet/vehicle/:id/picture/:pictureid/edit",

  FleetVehicleInvoiceSearchPageRouter = "/fleet/vehicle/:id/invoice",
  FleetVehicleInvoiceCreatePageRouter = "/fleet/vehicle/:id/invoice/new",
  FleetVehicleInvoiceEditPageRouter = "/fleet/vehicle/:id/invoice/:invoiceid/edit",

  FleetVehicleOfferSaleCreatePageRouter = "/fleet/vehicle/:id/offer/sale/new",
  FleetVehicleOfferSaleEditPageRouter = "/fleet/vehicle/:id/offer/:offerid/sale/edit",
  FleetVehicleOfferSearchPageRouter = "/fleet/vehicle/:id/offer",

  FleetVehicleContractSaleCreatePageRouter = "/fleet/vehicle/:id/contract/sale/new",
  FleetVehicleContractSaleEditPageRouter = "/fleet/vehicle/:id/contract/:contractid/sale/edit",
  FleetVehicleContractSearchPageRouter = "/fleet/vehicle/:id/contract",

  FleetVehicleHistorySearchPageRouter = "/fleet/vehicle/:id/history",

  FleetVehicleTransferSearchPageRouter = "/fleet/vehicle/:id/transfer",

  FleetVehicleDocumentCreatePageRouter = "/fleet/vehicle/:id/document/new",
  FleetVehicleDocumentEditPageRouter = "/fleet/vehicle/:id/document/:documentid/edit",
  FleetVehicleDocumentSearchPageRouter = "/fleet/vehicle/:id/document",

  FleetVehicleTireSetCreatePageRouter = "/fleet/vehicle/:id/tireset/new",
  FleetVehicleTireSetEditPageRouter = "/fleet/vehicle/:id/tire/:tiresetid/edit",
  FleetVehicleTireSetSearchPageRouter = "/fleet/vehicle/:id/tireset",

  FleetVehicleTireSetDocumentCreatePageRouter = "/fleet/vehicle/:id/tireset/:tiresetid/document/new",
  FleetVehicleTireSetDocumentEditPageRouter = "/fleet/vehicle/:id/tireset/:tiresetid/document/:documentid/edit",
  FleetVehicleTireSetDocumentSearchPageRouter = "/fleet/vehicle/:id/tireset/:tiresetid/document",

  FleetVehicleDriverCreatePageRouter = "/fleet/vehicle/:id/driver/new",
  FleetVehicleDriverEditPageRouter = "/fleet/vehicle/:id/driver/:driverid/edit",
  FleetVehicleDriverSearchPageRouter = "/fleet/vehicle/:id/driver",

  FleetVehicleExpenseCreatePageRouter = "/fleet/vehicle/:id/expense/new",
  FleetVehicleExpenseEditPageRouter = "/fleet/vehicle/:id/expense/:expenseid/edit",
  FleetVehicleExpenseSearchPageRouter = "/fleet/vehicle/:id/expense",

  FleetVehicleDamageSearchPageRouter = "/fleet/vehicle/:id/damage",

  FleetVehicleServiceSearchPageRouter = "/fleet/vehicle/:id/service",

  FleetVehicleFireExtinguisherCreatePageRouter = "/fleet/vehicle/:id/fireextinguisher/new",
  FleetVehicleFireExtinguisherEditPageRouter = "/fleet/vehicle/:id/fireextinguisher/:fireextinguisherid/edit",
  FleetVehicleFireExtinguisherSearchPageRouter = "/fleet/vehicle/:id/fireextinguisher",

}
